// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alertAndNotificaion .main {
  color: beige;
  text-align: left;
}

.alertAndNotificaion .alertNotification {
  width: 100%;
  height: 100%;
}

.alertAndNotificaion .dataList ul {
  list-style-type: none;
  padding: 0;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;
}

.alertAndNotificaion .css-x7o5da-MuiPaper-root-MuiAlert-root{
  background-color: none !important;

}

.alertAndNotificaion .dataList ul li {
  display: inline;
  padding: 10px;
  background-color: #777a84;
  width: 100% !important;
  border-right: 1px solid #313131;
}

.alertAndNotificaion .dataList ul li a:last-child {
  cursor: not-allowed;
}

.alertAndNotificaion .dataList ul li:first-child {
  background-color: #4996ee;
}

.alertAndNotificaion .dataList ul li a {
  display: inline;
  text-decoration: none;
  color: #e1e1e1;
  width: 100% !important;
}

.alertAndNotificaion .content table,
td,
th {
  border: 1px solid #282b30;
}

.alertAndNotificaion .content table {
  color: #e1e1e1;
  margin-top: 40px;
  width: 50%;
  height: 200px;
  border-collapse: collapse;
  text-align: center;
}

.alertAndNotificaion .content table td:first-child {
  background-color: #777a84;
}

.alertAndNotificaion .content table tr:nth-child(2) {
  background-color: #777a84;
}

.alertAndNotificaion .content table th {
  background-color: #4996ee;
}

.alertAndNotificaion .content table th:first-child {
  background-color: #777a84;
}

.alertAndNotificaion .content table td:second-child {
  background-color: #777a84;
}

.alertAndNotificaion input {
  background-color: #282b30;
  height: 30px;
  color: #e1e1e1;
}

.alertAndNotificaion nav ul {
  margin-top: 20px;
  cursor: pointer;
}

.alertAndNotificaion .calendar-and-notifications {
  height: 200px;
}

.alertAndNotificaion .App {
  background-color: #282b30;
  padding: 20px;
  height: 400px;
}
.alertAndNotificaion .notifications {
  max-height: 400px;
  overflow-y: scroll;
  padding-left: 20px;
  width: 100%;
  background-color: #282b30;
}

.alertAndNotificaion .react-calendar__month-view__days {
  height: 300px;
}

.alertAndNotificaion .react-calendar__tile {
  background-color: #282b30;
  color: #e1e1e1;
  border: 1px solid #313131 !important;
  cursor: pointer;
}

.alertAndNotificaion .react-calendar__year-view__months__month {
  height: 80px;
}

.alertAndNotificaion .react-calendar__decade-view__years__year {
  height: 80px;
}

.alertAndNotificaion
  .react-calendar__month-view__weekdays__weekday
  abbr[title] {
  color: #b8b8b8;
  text-decoration: none;
}

.alertAndNotificaion .react-calendar__navigation button {
  background-color: #282b30;
  color: #e1e1e1;
  border: 1px solid #c9c9c9 !important;
  cursor: pointer;
  margin-bottom: 25px;
}

.notifCard ul {
  list-style: none;
  padding: 0;
}
.notifCard {
  text-align: left;
  color: #e1e1e1;
  margin-bottom: 25px;
}

/* width */
.alertAndNotificaion ::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #282b30;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #555;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.alertButtonContainer .muteButton {
  background-color: #9b9b9b;
  color: #e1e1e1;
  border-radius: 0;
  font-size: 10px;
  display: inline-block;
}
.alertButtonContainer .viewFaultsButton {
  background-color: #e16162;
  color: #e1e1e1;
  border-radius: 0;
  font-size: 10px;
  display: inline-block;
  margin-left: 10px;
}

.add-notification-form {
  color: #e1e1e1;
}
.add-notification-form input {
  margin-top: 20px;
}
.add-notification-form button {
  background: linear-gradient(
    90deg,
    rgba(73, 150, 238) 0%,
    rgba(37, 75, 119) 100%
  );
  color: #e1e1e1;
  margin-left: 5px;
  border-radius: 0;
}
.add-notification-form button:hover {
  background: linear-gradient(
    90deg,
    rgba(37, 75, 119) 0%,
    rgba(73, 150, 238) 100%
  );
}

#tilteNewAlert {
  width: 100%;
}

#detailsNewAlert {
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  background-color: #282b30;
  color: #e1e1e1;
  margin-top: 20px;
}

.alertAndNotificaion .alertMenuItem {
  width: 99%;
  text-align: center;
  color: #e1e1e1;
  height: 40px;
  background-color: #777a84;

  justify-content: center;
  margin-top: 20px;
  margin-bottom: 10px;
  position: relative;
}
.alertAndNotificaion .alertMenuItem .activeLink {
  width: 100%;
  height: 40px;
  background-color: #4996ee;
}

.alertAndNotificaion .alertMenuItem a {
  width: 100% !important;
  text-align: center;
  color: #282b30;
  text-decoration: none;
}
.alertAndNotificaion .alertMenuItem .activeLink a {
  color: #e1e1e1;
}

.dataList .MuiGrid-item {
  padding: 0;
}
.margin-only {
  padding-top: 10px;
}

.alert-card {
  background-color: #282b30;
}

@media screen and (max-width: 900px) {
  .alertAndNotificaion .alertMenuItem {
    margin-top: 0;
  }

  .alertAndNotificaion .notifications {
    max-height: 400px;
    overflow-y: scroll;
    padding-left: 0;
    width: 100%;
    margin-top: 40px;
    background-color: #282b30;
  }
  .notifCard {
    margin-left: 20px;
  }
  .alertAndNotificaion .App {
    background-color: #282b30;
    padding: 20px;
    height: 1300px;
  }
  .alertAndNotificaion .AppEndpoints {
    text-align: center;
    padding: 20px;
    height: 1300px;
  }
  h1 {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AlertAndNotification/notificationEndpoints.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;;AAEnC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;;;;GAIC;EACD,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;;;;GAIC;AACH;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,yBAAyB;;EAEzB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;EAC3B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".alertAndNotificaion .main {\n  color: beige;\n  text-align: left;\n}\n\n.alertAndNotificaion .alertNotification {\n  width: 100%;\n  height: 100%;\n}\n\n.alertAndNotificaion .dataList ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled {\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n}\n\n.alertAndNotificaion .css-x7o5da-MuiPaper-root-MuiAlert-root{\n  background-color: none !important;\n\n}\n\n.alertAndNotificaion .dataList ul li {\n  display: inline;\n  padding: 10px;\n  background-color: #777a84;\n  width: 100% !important;\n  border-right: 1px solid #313131;\n}\n\n.alertAndNotificaion .dataList ul li a:last-child {\n  cursor: not-allowed;\n}\n\n.alertAndNotificaion .dataList ul li:first-child {\n  background-color: #4996ee;\n}\n\n.alertAndNotificaion .dataList ul li a {\n  display: inline;\n  text-decoration: none;\n  color: #e1e1e1;\n  width: 100% !important;\n}\n\n.alertAndNotificaion .content table,\ntd,\nth {\n  border: 1px solid #282b30;\n}\n\n.alertAndNotificaion .content table {\n  color: #e1e1e1;\n  margin-top: 40px;\n  width: 50%;\n  height: 200px;\n  border-collapse: collapse;\n  text-align: center;\n}\n\n.alertAndNotificaion .content table td:first-child {\n  background-color: #777a84;\n}\n\n.alertAndNotificaion .content table tr:nth-child(2) {\n  background-color: #777a84;\n}\n\n.alertAndNotificaion .content table th {\n  background-color: #4996ee;\n}\n\n.alertAndNotificaion .content table th:first-child {\n  background-color: #777a84;\n}\n\n.alertAndNotificaion .content table td:second-child {\n  background-color: #777a84;\n}\n\n.alertAndNotificaion input {\n  background-color: #282b30;\n  height: 30px;\n  color: #e1e1e1;\n}\n\n.alertAndNotificaion nav ul {\n  margin-top: 20px;\n  cursor: pointer;\n}\n\n.alertAndNotificaion .calendar-and-notifications {\n  height: 200px;\n}\n\n.alertAndNotificaion .App {\n  background-color: #282b30;\n  padding: 20px;\n  height: 400px;\n}\n.alertAndNotificaion .notifications {\n  max-height: 400px;\n  overflow-y: scroll;\n  padding-left: 20px;\n  width: 100%;\n  background-color: #282b30;\n}\n\n.alertAndNotificaion .react-calendar__month-view__days {\n  height: 300px;\n}\n\n.alertAndNotificaion .react-calendar__tile {\n  background-color: #282b30;\n  color: #e1e1e1;\n  border: 1px solid #313131 !important;\n  cursor: pointer;\n}\n\n.alertAndNotificaion .react-calendar__year-view__months__month {\n  height: 80px;\n}\n\n.alertAndNotificaion .react-calendar__decade-view__years__year {\n  height: 80px;\n}\n\n.alertAndNotificaion\n  .react-calendar__month-view__weekdays__weekday\n  abbr[title] {\n  color: #b8b8b8;\n  text-decoration: none;\n}\n\n.alertAndNotificaion .react-calendar__navigation button {\n  background-color: #282b30;\n  color: #e1e1e1;\n  border: 1px solid #c9c9c9 !important;\n  cursor: pointer;\n  margin-bottom: 25px;\n}\n\n.notifCard ul {\n  list-style: none;\n  padding: 0;\n}\n.notifCard {\n  text-align: left;\n  color: #e1e1e1;\n  margin-bottom: 25px;\n}\n\n/* width */\n.alertAndNotificaion ::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #282b30;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #555;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n.alertButtonContainer .muteButton {\n  background-color: #9b9b9b;\n  color: #e1e1e1;\n  border-radius: 0;\n  font-size: 10px;\n  display: inline-block;\n}\n.alertButtonContainer .viewFaultsButton {\n  background-color: #e16162;\n  color: #e1e1e1;\n  border-radius: 0;\n  font-size: 10px;\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.add-notification-form {\n  color: #e1e1e1;\n}\n.add-notification-form input {\n  margin-top: 20px;\n}\n.add-notification-form button {\n  background: linear-gradient(\n    90deg,\n    rgba(73, 150, 238) 0%,\n    rgba(37, 75, 119) 100%\n  );\n  color: #e1e1e1;\n  margin-left: 5px;\n  border-radius: 0;\n}\n.add-notification-form button:hover {\n  background: linear-gradient(\n    90deg,\n    rgba(37, 75, 119) 0%,\n    rgba(73, 150, 238) 100%\n  );\n}\n\n#tilteNewAlert {\n  width: 100%;\n}\n\n#detailsNewAlert {\n  width: 100%;\n  height: 200px;\n  margin-bottom: 20px;\n  background-color: #282b30;\n  color: #e1e1e1;\n  margin-top: 20px;\n}\n\n.alertAndNotificaion .alertMenuItem {\n  width: 99%;\n  text-align: center;\n  color: #e1e1e1;\n  height: 40px;\n  background-color: #777a84;\n\n  justify-content: center;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  position: relative;\n}\n.alertAndNotificaion .alertMenuItem .activeLink {\n  width: 100%;\n  height: 40px;\n  background-color: #4996ee;\n}\n\n.alertAndNotificaion .alertMenuItem a {\n  width: 100% !important;\n  text-align: center;\n  color: #282b30;\n  text-decoration: none;\n}\n.alertAndNotificaion .alertMenuItem .activeLink a {\n  color: #e1e1e1;\n}\n\n.dataList .MuiGrid-item {\n  padding: 0;\n}\n.margin-only {\n  padding-top: 10px;\n}\n\n.alert-card {\n  background-color: #282b30;\n}\n\n@media screen and (max-width: 900px) {\n  .alertAndNotificaion .alertMenuItem {\n    margin-top: 0;\n  }\n\n  .alertAndNotificaion .notifications {\n    max-height: 400px;\n    overflow-y: scroll;\n    padding-left: 0;\n    width: 100%;\n    margin-top: 40px;\n    background-color: #282b30;\n  }\n  .notifCard {\n    margin-left: 20px;\n  }\n  .alertAndNotificaion .App {\n    background-color: #282b30;\n    padding: 20px;\n    height: 1300px;\n  }\n  .alertAndNotificaion .AppEndpoints {\n    text-align: center;\n    padding: 20px;\n    height: 1300px;\n  }\n  h1 {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
